import React from 'react';

import StructureMapping from 'Flow2/util/StructureMapping.js';
import { format } from 'date-fns';

import DatePicker from "react-datepicker";
import addDays from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import Input from 'Flow2/components/UI/Input/Input';
import Checkbox from 'Flow2/components/UI/Checkbox/Checkbox';
import TagsTree from 'Flow2/components/TagsTree/TagTree';
import AddList from 'Flow2/components/AddList/AddList';
import UserList from 'Flow2/components/SelectionList/UserList';
import Countries from 'Flow2/components/CustomCollections/CustomDataJson/countries.json';
import { CONTENT_DATA } from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataConfig";

import RoomUserList from 'Flow2/components/AddList/RoomUserList';
import LinkAddList from 'Flow2/components/AddList/LinkAddList';

import MediaFile from 'Flow2/util/MediaFile.js';

import { FormattedMessage } from 'react-intl';

import { dateFormat, DATE_FORMAT } from 'Flow2/util/helperFunctions.js';
import * as Room from 'Flow2/util/Room.js';
import * as classes from 'Flow2/components/CustomCollections/CustomMix/CustomMix.module.scss';
import { Link } from 'react-router-dom';

const Datefield = (props) => {
    let theDate = "";
    if (props.date) {
        theDate = props.date;
    }
    const date = new Date(theDate.split(' ')[0]);
    const dateString = date.toLocaleDateString('de-DE', { 'year': 'numeric', 'month': '2-digit', 'day': '2-digit' });

    let max = null;
    if (props.maxDate) {
        max = new Date();
        max.setDate(max.getDate() + props.maxDate);
    }

    let min = null;
    if (props.minDate) {
        min = new Date();
        min.setDate(min.getDate() - props.minDate);
    }

    if (dateString == 'Invalid Date') {
        return (
            <div className={classes.cmdatapicker}>
                <DatePicker
                    locale={props.locale}
                    dateFormat={props.format}
                    maxDate={max}
                    minDate={min}
                    onChange={(selectedDate) => props.change(selectedDate, props.id)}
                    isClearable={true} />
            </div>
        );
    }

    return (
        <div className={classes.cmdatapicker}>
            <DatePicker
                locale={props.locale}
                dateFormat={props.format}
                selected={new Date(theDate.split(' ')[0])}
                maxDate={max}
                minDate={min}
                onChange={(selectedDate) => props.change(selectedDate, props.id)}
                isClearable={true} />
        </div>
    );
}

class MetadataElementHelper {

    static createElement(configType, key, value) {
        let obj = StructureMapping.getField(configType, key);

        if (!obj) {
            return null;
        }

        let element = {
            id: key,
            name: obj.name,
            intl: StructureMapping.getIntl(obj),
            order: StructureMapping.getOrder(obj),
            value: value,
            field: "",
            obj: obj
        };

        return element;
    }

    static createDisplayField(element, context) {
        if (!element || !element.obj || !element.value) {
            return "";
        }

        switch (StructureMapping.getType(element.obj)) {
            case 'text':
                return DisplayText(element, context);
            case 'textfield':
                return DisplayTextfield(element, context);
            case 'checkbox':
                return DisplayCheckbox(element, context);
            case 'dropdown':
                return DisplayDropdown(element, context);
            case 'radio':
                return DisplayRadio(element, context);
            case 'json':
                return DisplayJSON(element, context);
            case 'jsonarray':
                return DisplayJSONArray(element, context);
            case 'jsonobj':
                return DisplayJSONObj(element, context);
            case 'exif':
                return DisplayEXIF(element, context);
            case 'datetime':
                return DisplayDatetime(element, context);
            case 'link':
                return DisplayLink(element, context);
            case 'linklist':
                return DisplayLinklist(element, context);
            case 'internallink':
                return DisplayInernallink(element, context);
            case 'tagtree':
                return DisplayTagTree(element, context);
            case 'addlist':
                return DisplayAddList(element, context);
            case 'memberlist':
                return DisplayMemberList(element, context);
            case 'memberlist_auto':
                return DisplayMemberList(element, context, true);
            case 'linkaddlist':
                return DisplayLinkAddList(element, context);
            case 'userlist':
                return DisplayUserList(element, context);
            case 'userslist':
                return DisplayUsersList(element, context);
            case 'yearlist':
                return DisplayYearList(element, context);
            case 'countrylist':
                return DisplayCountryList(element, context);
            case 'contentlist':
                return DisplayContentList(element, context);
            case 'roommember':
                return DisplayRoommember(element, context);
            default:
                return element.value;
        }
    }

    static createEditField(element, context, massedit) {
        if (!element || !element.obj || !context) {
            return "";
        }

        switch (StructureMapping.getType(element.obj)) {
            case 'text':
                return EditText(element, context);
            case 'textfield':
                return EditTextfield(element, context, massedit);
            case 'checkbox':
                return EditCheckbox(element, context, massedit);
            case 'dropdown':
                return EditDropdown(element, context, massedit);
            case 'radio':
                return EditRadio(element, context, massedit);
            case 'datetime':
                return EditDatetime(element, context, massedit);
            case 'json':
                return DisplayJSON(element, context); // Display
            case 'jsonarray':
                return EditJSONArray(element, context); // Display
            case 'exif':
                return DisplayEXIF(element, context); // Display
            case 'link':
                return EditLink(element, context, massedit);
            case 'linklist':
                return EditLinklist(element, context, massedit);
            case 'internallink':
                return EditInernallink(element, context, massedit);
            case 'tagtree':
                return EditTagTree(element, context, massedit);
            case 'addlist':
                return EditAddList(element, context, massedit);
            case 'memberlist':
                return EditMemberList(element, context, massedit);
            case 'memberlist_auto':
                return EditMemberList(element, context, true);
            case 'linkaddlist':
                return EditLinkAddList(element, context, massedit);
            case 'userlist':
                return EditUserList(element, context, massedit);
            case 'userslist':
                return EditUsersList(element, context, massedit);
            case 'yearlist':
                return EditYearList(element, context, massedit);
            case 'countrylist':
                return EditCountryList(element, context, massedit);
            case 'contentlist':
                return EditContentList(element, context, massedit);
            case 'roommember':
                return EditRoommember(element, context, massedit);
            default:
                return element.value;
        }
    }

    static createSelectOptionList(element) {
        const options = StructureMapping.getOptions(element.obj);
        let inputs = [];

        for (let key in options) {
            inputs.push({ value: key, id: element.intl + ".dropdown." + key.replace(/\ /g, ""), displayValue: options[key] });
        }

        return inputs;
    }

    static isConditionSuccess(conditions, elements) {
        for (let key in conditions) {
            if (elements.hasOwnProperty(key)) {
                if ((typeof elements[key] === 'string') && elements[key].indexOf(conditions[key]) === -1) {
                    return false;
                }
            }
        }
        return true;
    }
}

export default MetadataElementHelper;

/********************* DISPLAY FIELDS ***********************/

const DisplayText = (element, context) => {
    if (StructureMapping.isDatefield(element.obj)) {
        return dateFormat(element.value.split(' ')[0], context.props.config.dateFormat);
    }

    // calc MB from B
    if (element.id === 'groesse') {
        return MediaFile.formatBytes(element.value);
    }

    if (StructureMapping.isHTML(element.obj)) {
        var doc = new DOMParser().parseFromString(element.value, "text/html");
        element.value = doc.documentElement.textContent;
    }

    // if value is numeric
    if(typeof element.value !== 'string') {
        element.value += "";
    }
    
    return (
        <span>{element.value.replace(/;/g, '; ')}</span>
    );
}

const DisplayTextfield = (element, context) => {
    return <pre className="DisplayField">{element.value}</pre>;
}

const DisplayCheckbox = (element, context) => {
    // prevent null exception
    const type = StructureMapping.getType(element.obj);
    let values = element.value.split(';');
    const options = StructureMapping.getOptions(element.obj);
    //LAMTEST BEGIN
    //LAMTEST END

    // make unique array
    values = [...new Set(values)];

    for (let i in values) {
        let optionValue = options[values[i]];
        let value = values[i];

        values[i] = "";
        if (optionValue !== undefined) {
            values[i] = (
                <FormattedMessage
                    id={element.intl + "." + type + "." + value}
                    key={element.intl + "." + type + "." + value} defaultMessage={optionValue}
                    children={(formattedMessage) => <>{formattedMessage}<br /></>}
                />
            );
        }
    }

    return values;
}

const DisplayDropdown = (element, context) => {
    return DisplayCheckbox(element, context);
}

const DisplayRadio = (element, context) => {
    return DisplayCheckbox(element, context);
}

const DisplayJSON = (element, context) => {
    let value;

    const createObjectOutput = (value) => {
        if (typeof value === 'object' && value !== null && StructureMapping.getJsonParam(element.obj)) {
            value = value[StructureMapping.getJsonParam(element.obj)] || "";
        }
        return value;
    }

    try {
        value = JSON.parse(element.value);
    } catch (ex) {
        return "";
    }

    if (!Array.isArray(value) && typeof value === 'object' && value !== null && StructureMapping.getJsonParam(element.obj)) {
        value = value[StructureMapping.getJsonParam(element.obj)] || "";
    }

    if (Array.isArray(value)) {
        value = value.map(item => {
            return (<span>{createObjectOutput(item)}</span>);
        });
        value = (<FlexColumn>{value}</FlexColumn>);
    }

    return (value);
}

const DisplayJSONArray = (element, context) => {
    let value;

    try {
        value = JSON.parse(element.value);
        if (!Array.isArray(value)) {
            throw new TypeError("No JSON Array: value in DisplayJSONArray");
        }
    } catch (ex) {
        return "";
    }

    value = value.map(item => {
        return (<span>{item}</span>);
    });
    
    value = (<FlexColumn>{value}</FlexColumn>);

    return (value);
}

const DisplayJSONObj = (element, context) => {
    let value;

    try {
        value = JSON.parse(element.value);
        
        console.log(value);
        
        if (typeof value !== 'object' || Array.isArray(value)) {
            throw new TypeError("No JSON Object: value in DisplayJSONObj");
        }
    } catch (ex) {
        return "";
    }

    const out = [];
    for(let key in value) {
        let val = value[key];
        if(Array.isArray(val) && val.length) {
            out.push(<span className="JsonObjKey">{key}:</span>);
            val.forEach(item => {
                out.push(<span>{item}</span>);
            });
        } else if (typeof val === 'string') {
            out.push(<span className="JsonObjKey">{key}:</span>);
            out.push(<span>{val}</span>);
        }
    }

    value = (<FlexColumn>{out}</FlexColumn>);

    return (value);
}

const DisplayEXIF = (element, context) => {
    //const input = '{"Make":"SONY","Model":"ILCE-7M4","Orientation":"Horizontal (normal)","XResolution":300,"YResolution":300,"ResolutionUnit":"inches","Software":"GIMP 2.10.34","ModifyDate":"2023-10-17T17:37:33.000Z","Artist":"Axel Jerabek","SampleFormat":{"0":3,"1":3,"2":3},"Copyright":"Axel Jerabek","ExposureTime":0.01,"FNumber":3.5,"ExposureProgram":"Aperture priority","ISO":2000,"RecommendedExposureIndex":2000,"ExifVersion":"2.3.2","DateTimeOriginal":"2023-10-17T15:55:41.000Z","CreateDate":"2023-10-17T15:55:41.000Z","BrightnessValue":2.384375,"ExposureCompensation":0.7,"MaxApertureValue":0.96875,"MeteringMode":"Pattern","LightSource":"Unknown","Flash":"Flash did not fire, compulsory flash mode","FocalLength":85,"SubSecTime":"398","SubSecTimeOriginal":"398","SubSecTimeDigitized":"398","ColorSpace":1,"FileSource":"Digital Camera","SceneType":"Directly photographed","CustomRendered":"Normal","ExposureMode":"Auto","WhiteBalance":"Auto","DigitalZoomRatio":1,"FocalLengthIn35mmFormat":85,"SceneCaptureType":"Standard","Contrast":"Normal","Saturation":"Normal","Sharpness":"Normal","LensInfo":[85,85,1.4,1.4],"LensModel":"85mm F1.4 DG DN | Art 020"}';
    let value;
    const output = [];

    try {
        value = JSON.parse(/*input*/element.value);
    } catch (ex) {
        return "";
    }
    
    console.log(value);
    
    if (!Array.isArray(value) && typeof value === 'object' && value !== null) {
        for(let key in value) {
            output.push(
                <div className={["EXIF"].join(' ')}>
                    <span className={["EXIFLabel"].join(' ')}>{key}</span>
                    <span className={["EXIFValue"].join(' ')}>{""+value[key]}</span>
                </div>
            );
        }
    }
    
    console.log(output);

    return (output);
}

const DisplayDatetime = (element, context) => {
    const datetime = element.value.split(' ');
    const theDate = dateFormat(datetime[0], context.props.config.dateFormat);

    if (theDate) {
        return theDate + ((datetime.length > 1) ? " " + datetime[1] : "");
    }

    return "";
}

const DisplayLink = (element, context) => {
    return (
        <span>
            <a href={element.value} title={element.value} target="_blank">{element.value}</a>
        </span>
    );
}

const DisplayLinklist = (element, context) => {
    const links = [];
    let hrefs = [];

    if (typeof element.value === 'string') {
        let value = element.value;
        if (value) {
            value = value.replace(/,$/g, "");
            value = value.replace(/\ /g, "");
            while (value.match(/,,/)) {
                value = value.replace(/,,/g, ",");
            }
        }
        hrefs = value.split(',');
    }

    hrefs.forEach(id => {
        let text = "";
        let href = id.match(/href="([^\'\"]*)/g);

        text = href = href[0].replace(/href="/, '');

        if (StructureMapping.isShort(element.obj)) {
            let substrs = text.split('/');
            if (substrs.length) {
                if (!substrs[substrs.length - 1]) {
                    text = substrs[substrs.length - 2];
                } else {
                    text = substrs[substrs.length - 1];
                }
            }
        }

        links.push(
            <span>
                <a href={href} title={href} target="_blank">{text}</a>
            </span>
        );
    });

    return links;
}

const DisplayInernallink = (element, context) => {
    const links = [];
    let ids = [];

    if (typeof element.value === 'string') {
        let value = element.value;
        if (value) {
            value = value.replace(/,$/g, "");
            value = value.replace(/\ /g, "");
            while (value.match(/,,/)) {
                value = value.replace(/,,/g, ",");
            }
        }
        ids = value.split(',');
    }

    ids.forEach((id, index) => {
        let clip = context.props.allClips[id];

        if (context.props.clipsLoadedByInternalLink && context.props.loadClipByInternalLink && context.props.removeClipByInternalLink) {
            if (!clip && !context.props.clipsLoadedByInternalLink[id]) {
                context.props.loadClipByInternalLink(id);
            } else if (clip && context.props.clipsLoadedByInternalLink[id]) {
                context.props.removeClipByInternalLink(id);
            }
        }

        // set onBack reference
        let from = context.state.id ? { from: context.state.id } : {};

        if (!clip) {
            // insert without link
            links.push(id);
        } else {
            if (index < (ids.length - 1)) {
                links.push(
                    <><Link
                        key={id}
                        to={{ pathname: "/clipdetails/" + id, state: { id: id, clips: /*context.props.location.state.clips ||*/[], ...from } }}
                        onClick={() => {
                            context.props.setCurrentClip(clip);
                        }}>
                        {id}
                    </Link>, </>
                );
            } else {
                links.push(
                    <Link
                        key={id}
                        to={{ pathname: "/clipdetails/" + id, state: { id: id, clips: /*context.props.location.state.clips ||*/[], ...from } }}
                        onClick={() => {
                            context.props.setCurrentClip(clip);
                        }}>
                        {id}
                    </Link>
                );
            }
        }
    });

    return links;
}

const DisplayTagTree = (element, context) => {
    if (!context) { return ""; }

    const tagtree = StructureMapping.getTagTree(element.obj);
    const referenceIds = StructureMapping.getTagTreeReferenceIds(element.obj);
    const value = context.getValue(referenceIds);

    if (value !== null) {
        const ids = value.split(';');

        return (
            <TagsTree
                key={context.state.id}
                data={tagtree}
                preSelectedTags={ids}
                lang={context.state.lang}
                defaultLang={context.props.config.tagsTreeDefaultLanguage}
                readonly={true}
            />
        );
    }

    // set empty pre selected tags to reset store
    return (
        <TagsTree
            key={context.state.id}
            data={tagtree}
            preSelectedTags={[]}
            lang={context.state.lang}
            defaultLang={context.props.config.tagsTreeDefaultLanguage}
            readonly={true}
        />
    );
}

const DisplayAddList = (element, context, auto = false) => {
	const list = MetadataElementHelper.createSelectOptionList(element);
    let data = [];
    if (element.value) {
        const separator = StructureMapping.getSeparatorParam(element.obj);
        if(separator) {
            data = element.value.split(separator);
        } else {
            if (element.value.indexOf(';') !== -1) {
                data = element.value.split(';');
            } else {
                data = element.value.split(',');
            }
        }
    }

	const valueField = (auto && 'id') || StructureMapping.getValueField(element.obj);
	const labelField = StructureMapping.getLabelField(element.obj);

    return (
        <AddList
            key={context.state.id}
			valueField={valueField}
            labelField={labelField}
            data={data}
			list={list.length ? list : null}
        />
    );
}

const DisplayLinkAddList = (element, context) => {
    return (
        <LinkAddList
            key={context.state.id}
            id={context.props.id}
            data={element.value}
        />
    );
}


const DisplayMemberList = (element, context, auto = false) => {
    return DisplayAddList(element, context, auto);
}


const DisplayUserList = (element, context) => {
    const params = StructureMapping.getUserList(element.obj);

    return (
        <UserList
            key={context.state.id}
            value={element.value}
            {...params}
        />
    );
}

const DisplayUsersList = (element, context) => {
    //return DisplayAddList(element, context);
    const params = StructureMapping.getUserList(element.obj);

    let data = [];
    if (element.value.indexOf(';') !== -1) {
        data = element.value.split(';');
    } else {
        data = element.value.split(',');
    }

    return (
        <AddList
            key={context.state.id}
            data={data}
            {...params}
        />
    );
}

const DisplayYearList = (element, context) => {
    const years = element.value.split(';');

    return (
        <AddList
            key={context.state.id}
            data={years}
            style="tab"
        />
    );
}

const DisplayCountryList = (element, context) => {
    if (!context) { return ""; }

    const countries = (element.value) ? element.value.split(';') : [];

    return (
        <AddList
            key={context.state.id}
            data={countries}
            list={Countries}
            valueField="ID"
            labelField={context.state.lang.toUpperCase()}
            style="tab"
        />
    );
}

const DisplayContentList = (element, context) => {
    if (!context) { return ""; }

    const contents = (element.value) ? element.value.split(';') : [];

    return (
        <AddList
            key={context.state.id}
            data={contents}
            list={CONTENT_DATA}
            valueField="ID"
            labelField={context.state.lang.toUpperCase()}
            style="tab"
        />
    );
}

const DisplayRoommember = (element, context) => {
    const roommember = Room.getRoomMember(element.value);

    return (
        <RoomUserList
            key={context.state.id}
            id={context.props.id}
            data={roommember.members}
            pwd={roommember.pwd}
            singlePassword={StructureMapping.isSinglePassword(element.obj)}
        />
    );
}

/********************* EDIT FIELDS ***********************/

const EditText = (element, context, massedit = false) => {
    if (StructureMapping.isDatefield(element.obj)) {
        return (
            <Datefield
                date={element.value}
                id={element.id}
                maxDate={StructureMapping.getMaxDate(element.obj)}
                minDate={StructureMapping.getMinDate(element.obj)}
                format={context.props.config.dateFormat || DATE_FORMAT}
                locale={context.state.lang}
                //change={context.dateChangedHandler}
                change={(value) => {
                    let dateString = value ? format(value, 'yyyy-MM-dd') : "";
                    context.changeHandler({ [element.id]: dateString });
                }}
            />
        );
    }

    if (StructureMapping.isTimefield(element.obj)) {
        return (
            <Input
                key={element.id}
                value={element.value ? element.value : ""}
                elementConfig={{ type: 'time', step: 2 }}
                changed={(event) => {
                    context.changeHandler({ [element.id]: event.target.value });
                    //context.inputChangedHandler(event.target.value, element.id)
                }}
            />
        );
    }

    return (
        <Input
            key={element.id}
            value={element.value ? element.value.replace(/;/g, '; ') : ""}
            elementConfig={{ type: 'text', placeholder: StructureMapping.hasPlaceholder(element.obj) || "" }}
            changed={(event) => {
                const value = event.target.value.replace(/; /g, ';');
                context.changeHandler({ [element.id]: value });
                //context.inputChangedHandler(event.target.value, element.id)
            }}
        />
    );
}

const EditTextfield = (element, context, massedit = false) => {
    return (
        <Input
            key={element.id}
            value={element.value ? element.value.replace(/;/g, '; ') : ""}
            elementType="textarea"
            changed={(event) => {
                const value = event.target.value.replace(/; /g, ';');
                context.changeHandler({ [element.id]: value });
                //context.inputChangedHandler(event.target.value, element.id)
            }}
        />
    );
}

const EditCheckbox = (element, context, massedit = false) => {
    if (!(context.structures && context.structures.checkbox && context.structures.checkbox[element.id])) {
        return "";
    }

    const structure = context.structures.checkbox[element.id]; // ref to structure obj
    const checkboxOptions = StructureMapping.getOptions(element.obj);
    const inputs = [];


    for (let key in checkboxOptions) {
        let checked = structure[key] ? "checked" : "";

        inputs.push(
            <Checkbox
                key={key}
                value={key}
                id={element.intl + ".checkbox." + key.replace(/\ /g, '')}
                label={checkboxOptions[key]}
                checked={checked}
                changed={(evt) => {
                    //context.checkboxChangeHandler(element.id, key)
                    structure[key] = !structure[key];

                    let values = [];
                    for (let key in structure) {
                        if (structure[key]) {
                            values.push(key);
                        }
                    }

                    context.changeHandler({ [element.id]: values.join(';') });
                    //context.inputChangedHandler(values.join(';'), element.id);
                }}
            />
        );
    }

    return inputs;
}

const EditDropdown = (element, context, massedit = false) => {
    const optionList = { options: MetadataElementHelper.createSelectOptionList(element) };

    return (
        <Input
            key={element.id}
            value={element.value ? element.value : ""}
            elementType="select_intl"
            elementConfig={optionList}
            changed={(event) => {
                context.changeHandler({ [element.id]: event.target.value });
                //context.inputChangedHandler(event.target.value, element.id)
            }}
        />
    );
}

const EditRadio = (element, context, massedit = false) => {
    const radioOptions = { options: MetadataElementHelper.createSelectOptionList(element) };

    return (
        <Input
            key={element.id}
            name={element.id}
            value={element.value ? element.value : ""}
            elementType="radio_intl"
            elementConfig={radioOptions}
            changed={(event) => {
                context.changeHandler({ [element.id]: event.target.value });
                //context.inputChangedHandler(event.target.value, element.id)
            }}
        />
    );
}

const EditDatetime = (element, context, massedit = false) => {
    let date = "";
    let time = "00:00";
    let datetime = [];
    let out = [];

    if (element.value) {
        datetime = element.value.split(' ');
        date = datetime[0];
        time = datetime[1];
    }

    out.push(
        <Datefield
            key={"date" + element.id}
            date={date}
            id={element.id}
            format={context.props.config.dateFormat || DATE_FORMAT}
            locale={context.state.lang}
            maxDate={StructureMapping.getMaxDate(element.obj)}
            minDate={StructureMapping.getMinDate(element.obj)}
            change={(value) => {
                if (value) {
                    let dateString = format(value, 'yyyy-MM-dd');
                    context.changeHandler({ [element.id]: dateString + " " + time });
                    //context.inputChangedHandler(dateString + " " + time, element.id);
                } else {
                    context.changeHandler({ [element.id]: "" });
                    //context.inputChangedHandler("", element.id);
                }
            }}
        />
    );

    out.push(
        <Input
            key={"time" + element.id}
            value={time}
            elementConfig={{ type: 'time' }}
            changed={(event) => {
                context.changeHandler({ [element.id]: date + " " + event.target.value });
                //context.inputChangedHandler(date + " " + event.target.value, element.id);
            }}
        />
    );

    return out;
}

const EditJSONArray = (element, context, massedit = false) => {
    return (
        <Input
            key={element.id}
            value={(element.value) ? element.value : ""}
            elementConfig={{ type: 'text' }}
            changed={(event) => {
                context.changeHandler({ [element.id]: event.target.value });
                //context.inputChangedHandler(event.target.value, element.id)
            }}
        />
    );
}

const EditLink = (element, context, massedit = false) => {
    return (
        <Input
            key={element.id}
            value={(element.value) ? element.value : ""}
            elementConfig={{ type: 'text' }}
            changed={(event) => {
                context.changeHandler({ [element.id]: event.target.value });
                //context.inputChangedHandler(event.target.value, element.id)
            }}
        />
    );
}

const EditLinklist = (element, context, massedit = false) => {
    const links = [];
    let hrefs = [];

    if (typeof element.value === 'string') {
        let value = element.value;
        if (value) {
            value = value.replace(/\ /g, "");
        }
        hrefs = value.split(',');
    }

    hrefs.forEach(id => {
        let href = id.match(/href="([^\'\"]*)/g);
        if (href) {
            href = href[0].replace(/href="/, '');
            links.push(href);
        }
    });

    let input = links.join(', ');

    return (
        <Input
            key={element.id}
            value={(input) ? input : ""}
            elementConfig={{ type: 'text' }}
            changed={(event) => {
                let value = event.target.value;
                if (value) {
                    while (value.match(/,,/)) {
                        value = value.replace(/,,/g, ",");
                    }
                    value = value.replace(/\ /g, "");
                }

                let hrefs = [];
                hrefs = value.split(',');

                const links = [];

                hrefs.forEach(href => {
                    links.push('<a href="' + href + '">' + href + '</a>');
                });

                context.changeHandler({ [element.id]: links.join(',') });
                //context.inputChangedHandler(links.join(','), element.id)
            }}
        />
    );
}

const EditInernallink = (element, context, massedit = false) => {
    return (
        <Input
            key={element.id}
            value={(element.value) ? element.value : ""}
            elementConfig={{ type: 'text' }}
            changed={(event) => {
                let value = event.target.value;
                if (value) {
                    while (value.match(/,,/)) {
                        value = value.replace(/,,/g, ",");
                    }
                    value = value.replace(/\ /g, "");
                }
                context.changeHandler({ [element.id]: value });
                //context.inputChangedHandler(value, element.id);
            }}
        />
    );
}

const EditTagTree = (element, context, massedit = false) => {
    if (!context) { return ""; }

    const tagtree = StructureMapping.getTagTree(element.obj);
    const referenceIds = StructureMapping.getTagTreeReferenceIds(element.obj);
    const value = context.getValue(referenceIds);
    let ids = (value !== null) ? value.split(';') : []; // set empty pre selected tag ids to reset store 

    return (
        <TagsTree
            data={tagtree}
            preSelectedTags={ids}
            field={element.id}
            refField={referenceIds}
            addHandler={(values, addedTag, field) => {
                //context.tagTreeAddHandler(values, addedTag);
                if (context.tagTreeAddHandler) {
                    // need for massedit
                    context.tagTreeAddHandler(values, addedTag, field);
                } else {
                    context.changeHandler(values);
                }
            }}
            removeHandler={(values, removedTag, field) => {
                //context.tagTreeRemoveHandler(values, removedTag);
                if (context.tagTreeRemoveHandler) {
                    // need for massedit
                    context.tagTreeRemoveHandler(values, removedTag, field);
                } else {
                    context.changeHandler(values);
                }
            }}
            lang={context.state.lang}
            defaultLang={context.props.config.tagsTreeDefaultLanguage}
        />
    );
}

const EditAddList = (element, context, massedit = false) => {
    const list = MetadataElementHelper.createSelectOptionList(element);
    let data = [];

    if (element.value) {
        const separator = StructureMapping.getSeparatorParam(element.obj);
        if(separator) {
            data = element.value.split(separator);
        } else {
            if (element.value.indexOf(';') !== -1) {
                data = element.value.split(';');
            } else {
                data = element.value.split(',');
            }
        }
    }
    
    return (
        <AddList
            key={context.state.id}
            data={data}
            list={list.length ? list : null}
            valueField={StructureMapping.getValueField(element.obj)}
            labelField={StructureMapping.getLabelField(element.obj)}
            add={(input) => {
                if (input && data.indexOf(input) === -1) {
                    data.unshift(input);
                    context.changeHandler({ [element.id]: data.join(';') });
                    //context.inputChangedHandler(data.join(';'), element.id);
                }
            }}
            remove={(index) => {
                let elm = data.splice(index, 1);
                context.changeHandler({ [element.id]: data.join(';') });
                //context.inputChangedHandler(data.join(';'), element.id);
            }}
        />
    );
}



const EditMemberList = (element, context, auto = false) => {
    let member = [];

    if (element.value) {
        if (element.value.indexOf(';') !== -1) {
            member = element.value.split(';');
        } else {
            member = element.value.split(',');
        }
    }

    return (
        <AddList
            key={context.state.id}
            data={member}
            valueField={auto && 'id'}
            add={(input) => {
                if (input && member.indexOf(input) === -1) {
                    member.unshift(input);
                    context.changeHandler({ [element.id]: member.join(';') });
                    //context.inputChangedHandler(member.join(';'), element.id);

                    if (context.addMemberHandler) {
                        context.addMemberHandler(input);
                    }
                }
            }}
            remove={(index) => {
                let elm = member.splice(index, 1);
                context.changeHandler({ [element.id]: member.join(';') });
                //context.inputChangedHandler(member.join(';'), element.id);

                if (context.removeMemberHandler && elm.length) {
                    context.removeMemberHandler(elm[0]);
                }

            }}
        />
    );
}

const EditLinkAddList = (element, context, massedit = false) => {
    return (
        <LinkAddList
            key={context.state.id}
            id={context.props.id}
            data={element.value}
            add={(value) => {
                context.changeHandler({ [element.id]: value });
                //context.inputChangedHandler(value, element.id); 
            }}
            remove={(value) => {
                context.changeHandler({ [element.id]: value });
                //context.inputChangedHandler(value, element.id); 
            }}
        />
    );
}

const EditUserList = (element, context, massedit = false) => {
    const params = StructureMapping.getUserList(element.obj);

    return (
        <UserList
            key={context.state.id}
            value={element.value}
            add={(input) => {
                context.changeHandler({ [element.id]: input });
                //context.inputChangedHandler(input, element.id); 
            }}
            {...params}
        />
    );
}

const EditUsersList = (element, context, massedit = false) => {
    const params = StructureMapping.getUserList(element.obj);
    let member = [];

    if (element.value) {
        if (element.value.indexOf(';') !== -1) {
            member = element.value.split(';');
        } else {
            member = element.value.split(',');
        }
    }

    return (
        <AddList
            key={context.state.id}
            data={member}
            add={(input) => {
                if (input && member.indexOf(input) === -1) {
                    member.unshift(input);
                    context.changeHandler({ [element.id]: member.join(';') });
                    //context.inputChangedHandler(member.join(';'), element.id);
                }
            }}
            remove={(index) => {
                let elm = member.splice(index, 1);
                context.changeHandler({ [element.id]: member.join(';') });
                //context.inputChangedHandler(member.join(';'), element.id);
            }}
            {...params}
        />
    );
}

const EditYearList = (element, context, massedit = false) => {
    const years = (element.value) ? element.value.split(';') : []
    const values = [];
    let dateNow = new Date();
    let maxYear = dateNow.getFullYear();

    if (dateNow.getMonth() > 6) {
        maxYear += 1;
    }
    for (let i = maxYear; i >= 1945; i--) {
        values.push({ year: i + "" });
    }

    return (
        <AddList
            key={context.state.id}
            data={years}
            list={values}
            valueField="year"
            labelField="year"
            style="tab"
            showAll={massedit} // indicates to show all options in dropdown
            add={(input) => {
                if (massedit && StructureMapping.isMassEditField(element.obj) && context.onAddMerged) {
                    years.push(input);
                    context.onAddMerged(years, input, element.id);
                } else {
                    years.push(input);
                    context.changeHandler({ [element.id]: years.join(';') });
                }
            }}
            remove={(index) => {
                if (massedit && StructureMapping.isMassEditField(element.obj) && context.onRemoveMerged) {
                    let removed = years.splice(index, 1);
                    context.onRemoveMerged(years, (removed.length && removed[0]) || "", element.id);
                } else {
                    years.splice(index, 1);
                    context.changeHandler({ [element.id]: years.join(';') });
                }
            }}
        />
    );
}

const EditCountryList = (element, context, massedit = false) => {
    const countries = (element.value) ? element.value.split(';') : [];

    return (
        <AddList
            key={context.state.id}
            data={countries}
            list={Countries}
            valueField="ID"
            labelField={context.state.lang.toUpperCase()}
            style="tab"
            add={(input) => {
                countries.push(input);
                context.changeHandler({ [element.id]: countries.join(';') });
                //context.inputChangedHandler(countries.join(';'), element.id);
            }}
            remove={(index) => {
                countries.splice(index, 1);
                context.changeHandler({ [element.id]: countries.join(';') });
                //context.inputChangedHandler(countries.join(';'), element.id);
            }}
        />
    );
}

const EditContentList = (element, context, massedit = false) => {
    const contents = (element.value) ? element.value.split(';') : [];

    return (
        <AddList
            key={context.state.id}
            data={contents}
            list={CONTENT_DATA}
            valueField="ID"
            labelField={context.state.lang.toUpperCase()}
            style="tab"
            showAll={massedit} // indicates to show all options in dropdown
            add={(input) => {
                if (massedit && StructureMapping.isMassEditField(element.obj) && context.onAddMerged) {
                    contents.push(input);
                    context.onAddMerged(contents, input, element.id);
                } else {
                    contents.push(input);
                    context.changeHandler({ [element.id]: contents.join(';') });
                }
            }}
            remove={(index) => {
                if (massedit && StructureMapping.isMassEditField(element.obj) && context.onRemoveMerged) {
                    let removed = contents.splice(index, 1);
                    context.onRemoveMerged(contents, (removed.length && removed[0]) || "", element.id);
                } else {
                    contents.splice(index, 1);
                    context.changeHandler({ [element.id]: contents.join(';') });
                }
            }}
        />
    );
}

const EditRoommember = (element, context, massedit = false) => {
    const roommember = Room.getRoomMember(element.value);

    return (
        <RoomUserList
            key={context.state.id}
            id={context.props.id}
            data={roommember.members}
            pwd={roommember.pwd}
            singlePassword={StructureMapping.isSinglePassword(element.obj)}
            add={(value) => {
                context.changeHandler({ [element.id]: value });
                //context.inputChangedHandler(value, element.id); 
            }}
            remove={(value) => {
                context.changeHandler({ [element.id]: value });
                //context.inputChangedHandler(value, element.id); 
            }}
        />
    );
}
